import React, { useEffect, useState } from 'react';
import { Button, Container, Row, Col, Alert, Form, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from "sweetalert2";
import Layout from '../../../../layout/default';

const UserDetailSelect = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [userDetails, setUserDetails] = useState(null);
  const [error, setError] = useState('');

  const maskSensitiveData = (data) => {
    if (typeof data === 'string' && data.length >= 4) {
      return data.slice(0, 4) + " **** " + data.slice(-4);
    }
    return data || "";
  };

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    if (authToken) {
      const fetchUserDetails = async () => {
        try {
          Swal.fire({
            title: 'Loading...',
            text: 'Fetching your details. Please wait.',
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });

          const response = await axios.get(`${process.env.REACT_APP_HOST}api/getUserdetails`, {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          });

          if (response.data.data) {
            setUserDetails(response.data.data);
          } else {
            setUserDetails(null);
          }
          setLoading(false);
          Swal.close();
        } catch (err) {
          console.error("Error fetching User Details:", err);
          if (err.response && err.response.data.success === false) {
            Swal.fire({
              icon: 'warning',
              title: 'User Details Not Found',
              text: 'We could not find your Details. Please add one.',
            }).then(() => {
              navigate("/shop/auths/add-user-details");
            });
          } else {
            setError("Failed to fetch address. Please try again.");
          }
        }
      };
      fetchUserDetails();
    } else {
      setLoading(false);
      setError('No auth token found. Please log in.');
      navigate("/shop/auths/login", { replace: true });
    }
  }, [navigate]);

  const handleCreate = () => {
    navigate('/shop/auths/add-user-details');
  };

  const handleEdit = () => {
    if (userDetails && userDetails.id) {
      navigate(`/shop/auths/update-user-details/${userDetails.id}`);
    } else {
      setError('No user found to edit.');
    }
  };

  return (
    <Layout title="User Details">
      <Container className="mt-4 flex-grow-1" style={{ maxWidth: '100%', padding: '0 15px' }}>
        <Row className="justify-content-md-center">
          <Col md={8}>
            {error && <Alert variant="danger">{error}</Alert>}
            <Card className="shadow-sm p-3 mb-5 bg-white rounded">
              <Card.Body className="px-3 py-3">
                <h3 className="text-center mb-4">User Details</h3>
                <p><strong>First Name:</strong> {userDetails?.first_name || 'N/A'}</p>
                <p><strong>Last Name:</strong> {userDetails?.last_name || 'N/A'}</p>
                <p><strong>Middle Name:</strong> {userDetails?.middle_name || 'N/A'}</p>
                <p><strong>Phone 1:</strong> {userDetails?.phone_1 || 'N/A'}</p>
                <p><strong>Phone 2:</strong> {userDetails?.phone_2 || 'N/A'}</p>
                <Form.Group>
                  <Form.Label>Aadhar Number</Form.Label>
                  <Form.Control
                    type="text"
                    value={maskSensitiveData(userDetails?.aadhar_number?.data || '')}
                    disabled
                    style={{ fontWeight: 'bold', backgroundColor: '#f8f9fa' }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>PAN Card Number</Form.Label>
                  <Form.Control
                    type="text"
                    value={maskSensitiveData(userDetails?.pancard_number || '')}
                    disabled
                    style={{ fontWeight: 'bold', backgroundColor: '#f8f9fa' }}
                  />
                </Form.Group>
                <Button
                  variant="primary"
                  className="mt-3 w-100"
                  onClick={handleEdit}
                  style={{ fontWeight: 'bold' }}
                >
                  Edit User Details
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <br />
      <br />
    </Layout>
  );
};

export default UserDetailSelect;
